import { LOCALE } from '@/config';

export const formatCost = (n: number | null) => (n !== null ? `$${n.toFixed(2)}` : '—');
export const formatMs = (ms: number | null) => (ms !== null ? `${ms.toLocaleString()} ms` : '—');
export const formatSec = (s: number | null) => (s !== null ? `${parseFloat(s.toFixed(1))}s` : '—');
export const formatConfidence = (value: number) =>
  `${value <= 1 ? (value * 100).toFixed(1) : value.toFixed(1)}%`;

export const formatAudioMinutes = (seconds: number) => {
  const minutes = seconds / 60;
  if (minutes >= 60) {
    return `${(minutes / 60).toFixed(1)} hr`;
  }
  if (minutes >= 10) {
    return `${Math.round(minutes)} min`;
  }
  return `${minutes.toFixed(1)} min`;
};
// export const formatNumber = (n: number | null) => (n !== null ? n.toLocaleString() : '—');

export function formatCompactNumber(n: number): string {
  return new Intl.NumberFormat(LOCALE, { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}

export function formatNumber(amount: number, locale = LOCALE) {
  const formatted = Number.isInteger(amount)
    ? new Intl.NumberFormat(locale).format(amount)
    : new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
  return formatted;
}
